import { Reveal } from "@/components/Reveal";

const STEPS = [
  { n: 1, title: "Buyer requirement", note: "Product, indicative grade and approximate quantity recorded." },
  { n: 2, title: "Lot identification", note: "Requirement matched against the lot currently in stock." },
  { n: 3, title: "Lot inspection", note: "Material inspected visually for condition, colour and cleanliness." },
  { n: 4, title: "Grade-wise segregation", note: "Sorted into indicative size categories where applicable." },
  { n: 5, title: "Actual-lot sample", note: "Lot photograph or physical sample shared for your approval." },
  { n: 6, title: "Written quotation", note: "Rate, specification, quantity and validity confirmed in writing." },
  { n: 7, title: "Weighing and packing", note: "Weighed before packing in suitable wholesale packaging." },
  { n: 8, title: "Dispatch", note: "Handed over to the transporter with GST invoice and LR / docket." },
  { n: 9, title: "Follow-up and reorder", note: "Delivery confirmed and repeat requirements recorded." },
];

export const SupplyProcess = () => {
  return (
    <section id="nine-step-process" className="py-16 bg-spice-green-dark text-white px-4 sm:px-6" data-testid="supply-process-section">
      <div className="max-w-7xl mx-auto space-y-10">
        <Reveal className="max-w-2xl space-y-2">
          <span className="text-xs font-bold uppercase tracking-widest text-spice-gold">Execution workflow</span>
          <h2 className="text-2xl sm:text-3xl font-bold">Nine-Step Supply Process</h2>
          <p className="text-sm text-spice-sage">
            How each wholesale order is handled, from requirement gathering to dispatch and reorder.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {STEPS.map((step, i) => (
            <Reveal key={step.n} delay={(i % 3) * 60}>
              <div className="bg-spice-green/60 p-5 rounded border border-white/10 space-y-1.5 h-full" data-testid={`full-process-step-${step.n}`}>
                <div className="text-[11px] font-bold text-spice-gold">Step {step.n}</div>
                <div className="text-sm font-semibold">{step.title}</div>
                <p className="text-xs text-spice-sage leading-relaxed">{step.note}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
